export default __webpack_public_path__ + "static/media/simpleAndEasyOrdering.ff69b133.png";